import { graphql } from '../graphql';
import { useRequest } from './client/useRequest';
export const SEND_SECURE_FORM_TOKEN = graphql(`
  mutation SendSecureFormToken(
    $id: String!
    $invitationId: String!
    $token: String!
    $timestamp: String!
  ) {
    sendSecureFormToken(
      input: {
        id: $id
        invitationId: $invitationId
        token: $token
        timestamp: $timestamp
      }
    )
  }
`);
export const useSendSecureFormTokenRequest = () => {
    return useRequest(SEND_SECURE_FORM_TOKEN, {});
};
